<form class="schedule-settings-form" [formGroup]="formGroup" ngNativeValidate>
    <mat-grid-list cols="2" rowHeight="95px">
        <mat-grid-tile>
            <div class="container">
                <mat-slide-toggle class="turn-on-slider" [formControl]="turnOnThreadsSchedulerControl">
                    Turn On</mat-slide-toggle>
            </div>
        </mat-grid-tile>
        <mat-grid-tile></mat-grid-tile>
        <mat-grid-tile>
            <mat-form-field appearance="fill">
                <mat-label>Thread count control</mat-label>
                <input matInput type="number" placeholder="e.g. 30"
                    [formControl]="optimalThreadsPerEc2InstanceCountControl" min="1">
                <span matSuffix class="value-suffix">
                    <mat-icon class="help-icon"
                        [matTooltip]="'Optimal thread count that can safely be processed on a single server instance.'">
                        info
                    </mat-icon>Threads
                </span>
                <mat-error
                    *ngIf="optimalThreadsPerEc2InstanceCountControl.invalid && optimalThreadsPerEc2InstanceCountControl.errors.min">Min
                    threads count: {{minOptimalThreadsPerEc2InstanceCount}}
                </mat-error>
                <mat-error
                    *ngIf="optimalThreadsPerEc2InstanceCountControl.invalid && optimalThreadsPerEc2InstanceCountControl.errors.max">Max
                    threads count: {{maxOptimalThreadsPerEc2InstanceCount}}
                </mat-error>
                <mat-error
                    *ngIf="optimalThreadsPerEc2InstanceCountControl.invalid && optimalThreadsPerEc2InstanceCountControl.errors.pattern">Only
                    integer numbers allowed
                </mat-error>
            </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile>
            <mat-form-field appearance="fill">
                <mat-label>Thread increase Interval</mat-label>
                <input matInput type="number" placeholder="e.g. 30" [formControl]="threadsIncreaseIntervalMinControl"
                    min="0" (blur)="formatInput()">
                <span matSuffix class="value-suffix">
                    <mat-icon class="help-icon"
                        [matTooltip]="'Each thread needs a warm-up time interval. This value sets the interval time the auto-scheduler will use before adding a new thread. '">
                        info
                    </mat-icon>Minutes
                </span>
                <mat-error
                    *ngIf="threadsIncreaseIntervalMinControl.invalid && threadsIncreaseIntervalMinControl.errors.min">Min
                    interval: {{minThreadsIncreaseIntervalMin}} minutes
                </mat-error>
                <mat-error
                    *ngIf="threadsIncreaseIntervalMinControl.invalid && threadsIncreaseIntervalMinControl.errors.max">Max
                    interval: {{maxThreadsIncreaseIntervalMin}} minutes
                </mat-error>
                <mat-error
                    *ngIf="threadsIncreaseIntervalMinControl.invalid && threadsIncreaseIntervalMinControl.errors.pattern">Only
                    numbers allowed
                </mat-error>
            </mat-form-field>
        </mat-grid-tile>
    </mat-grid-list>
</form>